<template>
<div class="size margin">

  <div class="example">
    <titleComponent value="Tags" mark="01" color="background-yellow" />
    <div class="container wrap margin-left-20">
      <div v-for="(x, index) in tags">
        <div class="tag" :class="x">Nível {{index + 1}}</div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import titleComponent from '@/components/titleComponent'

export default {
  components: {
    titleComponent
  },
  name: 'tags',
  data () {
    return {
      tags: ['tag-one', 'tag-two', 'tag-three', 'tag-four', 'tag-five', 'tag-six']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/styleguide/tags.vue